import { render, staticRenderFns } from "./IconPolygonFreeHand.vue?vue&type=template&id=2b07b6a8"
import script from "./IconPolygonFreeHand.vue?vue&type=script&lang=js"
export * from "./IconPolygonFreeHand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports